export default{
    methods: {
        constructUrlParams($url_path, params = []){
           
            if(params.length > 0){
                 //TODO EXPAND
            }
            return $url_path+'?lang='+this.$vuetify.lang.current;
        }
    }
}